import { CAR_PURCHASE_STATUS } from '@/constants/constants';

import { HotspotData, ProductDetailsPayloadFields, ProductDetailsPayloadImages } from './ProductDetail.type';

export const PRODUCT_CATALOGUE_LIMIT = 36;

export interface ProductListDataRow {
  sku: string;
  price: string;
  title: string;
  variant: string;
  buildYear: number;
  transmission: string;
  fuelType: string;
  kilometres: string;
  card: string;
  dutyPrice: string;
  defaultRate: number;
  weeklyRepayment: number;
  isLoading?: boolean;
  id: string;
  status: CAR_PURCHASE_STATUS;
  images: ProductDetailsPayloadImages;

  search_keywords: string[];
  make: string;
  model: string;
  colour: string;
  body: string;
  ancapRating: string;
  watchers?: number;
  hotspots?: HotspotData;
  [ProductDetailsPayloadFields.remainingWarrantyMonths]: number;
  cardImages: string[];
}

interface DeliveryAddress {
  city: string;
  country: string;
  postalCode: string;
  state: string;
  streetName: string;
  streetNumber: string;
}

interface Vehicle {
  sku?: string;
  id?: string;
}

enum StateOrder {
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
}

export interface OrdersResponse {
  deliveryDate: string | null;
  deliveryAddress: DeliveryAddress;
  deliveryState: string;
  deliveryTime: string | null;
  id: string;
  orderNumber: string;
  totalPrice: number;
  state: StateOrder;
  vehicle: Vehicle;
  deliveryDateTimeFrom?: string;
  pickUpFlag?: boolean;
}

export interface ProductListDataPayload {
  total: number;
  results: ProductListDataRow[];
  recommendation_id?: string | null;
}

export const enum FilterValues {
  Make = 'make',
  Model = 'model',
  CashMin = 'cashMin',
  CashMax = 'cashMax',
  FinanceMin = 'financeMin',
  FinanceMax = 'financeMax',
  YearMin = 'yearMin',
  YearMax = 'yearMax',
  KMMin = 'kmMin',
  KMMax = 'kmMax',
  EnginePowerMin = 'enginePowerMin',
  EnginePowerMax = 'enginePowerMax',
  FuelConsumptionMin = 'fuelConsumptionMin',
  FuelConsumptionMax = 'fuelConsumptionMax',
  Transmission = 'transmission',
  HighlightedFeatures = 'highlightedFeatures',
  FuelType = 'fuelType',
  /** Parent fuel row (`fuel_type_hierarchy` parent facet), like Make */
  FuelCategory = 'fuelCategory',
  /** Sub-fuel row (`fuel_type_hierarchy` leaf facet), like Model */
  FuelSubType = 'fuelSubType',
  BodyType = 'bodyType',
  BodySize = 'bodySize',
  DriveType = 'driveType',
  Seats = 'seats',
  Doors = 'doors',
  Colour = 'colour',
  Ancap = 'ancap',
  Co2emissions = 'co2emissions',
  TowCapBrakedMin = 'towCapBrakedMin',
  TowCapBrakedMax = 'towCapBrakedMax',
  Keyword = 'keyword',
  State = 'state',
  promotionTags = 'search_keywords',
}

export interface FinanceQuotesResponse {
  count: number;
  results: QuotesCard[];
}

export interface QuotesCard {
  id: string;
  financier: string;
  rate: number;
  repaymentAmountCents: number;
  termMonths: number;
  createdAt: Date;
  buildYear: string;
  loanAmountCents: number;
  vehiclePriceCents: number;
  fees: QuotesFees;
  reCalculatedRepaymentAmountCents: number | null;
  discountedRate: number | null;
  loanType: string;
  quoteRequestId: string;
}

interface QuotesFees {
  brokerFeeCents: number;
  establishmentFeeCents: number;
  ppsrFeeCents: number;
  repaymentFeeCents: number;
  discountedBrokerFeeCents: number | null;
}

export interface UnavailableProductListDataPayload {
  total: number;
  results: UnavailableProductListDataRow[];
}

interface UnavailableProductListDataRow {
  sku: string;
  status: CAR_PURCHASE_STATUS;
}
